import Vue from 'vue'
import { library, config, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// import { fas } from '@fortawesome/pro-solid-svg-icons'
// import { far } from '@fortawesome/pro-regular-svg-icons'
// import { fal } from '@fortawesome/pro-light-svg-icons'
import { faApple, faFacebook, faGoogleDrive, faDropbox, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faLifeRing } from '@fortawesome/pro-regular-svg-icons'
// ALL LIGHT ICONS
import {
  faArrowsH,
  faArrowsV,
  faEdit,
  faCamera,
  faAlignCenter,
  faCircle,
  faFile,
  faChevronRight,
  faPlus,
  faMinus,
  faChevronCircleUp,
  faTrashAlt,
  faCopy,
  faLevelUpAlt,
  faLevelDownAlt,
  faArrowToTop,
  faArrowToBottom,
  faLayerGroup,
  faObjectGroup,
  faObjectUngroup as faObjectUngroupLight,
  faMagnet,
  faUndo,
  faRedo,
  faFillDrip,
  faTextWidth,
  faBars,
  faPalette,
  faFont,
  faItalic,
  faUnderline,
  faAlignLeft,
  faAlignRight,
  faAlignJustify,
  faCrosshairs,
  faDrawSquare,
  faCloudUpload,
  faQuestionCircle,
  faPaintRoller,
  faExchange,
  faTachometerAlt


} from '@fortawesome/pro-light-svg-icons'
import {
  faRectangleWide,
  faBan,
  faBrush,
  faObjectUngroup
} from '@fortawesome/pro-solid-svg-icons'

config.showMissingIcons = true
// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false

// Add all icons to the library so you can use it in your page
library.add(
  faApple,
  faLifeRing,
  faRectangleWide,
  faFacebook,
  faGoogleDrive,
  faDropbox,
  faInstagram,
  faArrowsH,
  faArrowsV,
  faLayerGroup,
  faLevelUpAlt,
  faLevelDownAlt,
  faArrowToTop,
  faArrowToBottom,
  faObjectGroup,
  faObjectUngroup,
  faObjectUngroupLight,
  faMagnet,
  faBan,
  faBrush,
  // light
  faEdit,
  faCamera,
  faAlignCenter,
  faCircle,
  faFile,
  faChevronRight,
  faPlus,
  faMinus,
  faChevronCircleUp,
  faTrashAlt,
  faCopy,
  faArrowToBottom,
  faUndo,
  faRedo,
  faFillDrip,
  faTextWidth,
  faBars,
  faPalette,
  faFont,
  faItalic,
  faUnderline,
  faAlignLeft,
  faAlignRight,
  faAlignJustify,
  faCrosshairs,
  faDrawSquare,
  faCloudUpload,
  faQuestionCircle,
  faPaintRoller,
  faExchange,
  faTachometerAlt
)

// dom.watch()

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
